import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.42777 1.5052C7.3475 1.50364 6.28649 1.79121 5.35486 2.33805C4.42322 2.8849 3.65491 3.67111 3.12964 4.61508C2.60437 5.55905 2.3413 6.62639 2.36771 7.70634C2.39413 8.78629 2.70907 9.83949 3.27986 10.7567L1.5 14.4948L5.23753 12.7149C6.03463 13.2105 6.93592 13.5142 7.8704 13.6021C8.80488 13.69 9.747 13.5598 10.6226 13.2215C11.4981 12.8833 12.2831 12.3464 12.9158 11.6531C13.5485 10.9598 14.0116 10.129 14.2685 9.22626C14.5254 8.3235 14.5692 7.37342 14.3964 6.45086C14.2235 5.52831 13.8389 4.65848 13.2726 3.90993C12.7063 3.16138 11.974 2.55455 11.1333 2.13725C10.2925 1.71995 9.36637 1.50358 8.42777 1.5052V1.5052Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChat;
